module.exports = __webpack_public_path__ + "static/media/loading_data_sample_templete - Sheet1.2eadfa07.csv";